import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Container, Item, ItemsContainer, StyledLogoutIcon, StyledUserProfileIcon } from './ProfilePopover.styles';

interface ProfilePopoverProps {
  onClose?: () => void;
  onLogout?: () => void;
}

const ProfilePopover = ({ onClose, onLogout }: ProfilePopoverProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const onEdit = () => {
    navigate('/app/settings/profile/accountDetails');
    onClose?.();
  };

  return (
    <Container>
      <ItemsContainer>
        <Item onClick={onEdit}>
          <StyledUserProfileIcon />
          {t('profile.myAccount')}
        </Item>
        <Item onClick={onLogout}>
          <StyledLogoutIcon />
          {t('profile.logout')}
        </Item>
      </ItemsContainer>
    </Container>
  );
};

export default ProfilePopover;
